import Service from "../service";
import AuthService from "../AuthService";


const User = {
  getAllUser(page) {
    return AuthService.get('/api/get-all-user?page='+page);
  },
  getSearchAllUser(data) {
    return AuthService.get('/api/get-search-all-user?page='+data.page+'&word='+data.word);
  },
  getUser(id) {
    return AuthService.get(`/api/user/${id}`);
  },
  saveAccount(data) {
    return AuthService.post('/api/user', data);
  },
  editAccount(data) {
    // console.log(data)
    return AuthService.post('/api/editUser', data);
  },
  deleteAccount(data) {
    return AuthService.post('/api/deleteUser', data);
  },
  searchUser(data) {
    return AuthService.get('/api/search-user?page='+data.page+'&word='+data.word);
  },
  searchOrganization(data) {
    return AuthService.get('/api/search-organization?page='+data.page+'&word='+data.word);
  }
};

export default User;
